import { useState, useEffect } from "react";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { sliderData } from "./slider-data";
import  "./Slider.css";

const Slider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slideLength = sliderData.length;

  const autoScroll = true;
  let slideInterval;
  let intervalTime = 5000;

  const nxetSlide = () => {
    setCurrentSlide(currentSlide === slideLength -1 ? 0 : currentSlide + 1);
  }

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slideLength -1 :  currentSlide - 1);
  }

  function auto() {
    slideInterval = setInterval(nxetSlide, intervalTime)
  }

  useEffect(() => {
    setCurrentSlide(0)
  }, []);

  useEffect(() => {
    if(autoScroll) {
        auto()
    }
    return  () => clearInterval(slideInterval);
  }, [currentSlide]);
  return (
    <div className="slider">
        <FaArrowLeft className="arrow prev" onClick={prevSlide} />
        <FaArrowRight className="arrow next" onClick={nxetSlide} />

        {sliderData.map((slide, index) => {
            return (
                <div className={index === currentSlide ? "slide current" : "slide"} key={index}>
                    {index === currentSlide && (
                        <>
                        <div
                          className="img"
                          style={{
                          width: "100%",
                          height: "100%",
                          backgroundImage: `url(${slide.image})`,
                          backgroundSize: "cover",
                          }}
                        ></div>
                        <div className="content">
                        </div>
                        </>
                    )}
                </div>
            )
        })}

    </div>
)}

export default Slider;

